export default __webpack_public_path__ + "static/media/bluLogo.b6b49ab5.svg";